import { connect } from "react-redux";
import ActivityWatcher from "./ActivityWatcher";
import { IStateTree } from "../../store/interfaces";

const mapStateToProps = ({ user: userState }: IStateTree) => ({
  userState,
});

export default connect(mapStateToProps)(ActivityWatcher);
